import { type POSSIBLE_METRICS_ENUM } from "constants/metrics"
import { useFetch, type EndpointsGET } from "data/api/useFetch"
import type { MetricsListItem as APIMetricsListItem } from "@tokenterminal/tt-analytics-api-types/dist/api/lists"

const endpoint: EndpointsGET = "/v3/internal/lists/metrics"

interface Options {
  suspense?: boolean
  shouldFetch?: boolean
}

const defaults: Options = {}

export interface MetricsListItem extends Omit<APIMetricsListItem, "metric_id"> {
  metric_id: POSSIBLE_METRICS_ENUM
}

export const useMetricsList = ({
  suspense = true,
  shouldFetch = true,
}: Options = defaults) => {
  const data = useFetch(endpoint) as { data: Array<MetricsListItem> }

  return data
}
